"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var selectors_1 = require("../../selectors");
var RequestAudit_1 = __importDefault(require("../RequestAudit"));
var UnlockReportCallOut_1 = __importDefault(require("../UnlockReportCallOut"));
var AuditCallout = function () {
    var isBlocked = (0, react_redux_1.useSelector)(selectors_1.selectBlockSaasAuditParts);
    var audit = (0, react_redux_1.useSelector)(selectors_1.selectLatestAudit);
    if (!(audit === null || audit === void 0 ? void 0 : audit.isDummy) && !isBlocked) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ maxWidth: 1080, pt: 3 }, { children: isBlocked ? (0, jsx_runtime_1.jsx)(UnlockReportCallOut_1.default, {}) : (0, jsx_runtime_1.jsx)(RequestAudit_1.default, {}) }));
};
exports.default = AuditCallout;
